<template>
    <div class='main'>
        <p class='help'>保護者氏名・お子さまのお名前は、<router-link to='/photobuy/mypage?to=profile'>プロフィール設定</router-link>から登録・変更できます。</p>
        <p v-if='requiresGuardianName && !guardianName' class='notification is-warning'>発送をご希望の場合は、プロフィール設定で保護者氏名を登録してください。カートの内容は保持されます。</p>
        <form class='form'>
            <div v-if='children.length' class='field'>
                <label class='label' for='order-child'>ご注文のお子さま（任意・1人）</label>
                <div class='select'>
                    <select id='order-child' v-model='childId'>
                        <option value=''>選択しない</option>
                        <option v-for='child in children' :key='child.id' :value='child.id'>{{ child.name }}</option>
                    </select>
                </div>
                <p class='help'>未選択のままでも注文できます。発送先の保護者氏名は変わりません。</p>
            </div>
            <div class="field">
                <label class="label">{{ requiresGuardianName ? '発送先の保護者氏名' : '学年・組・氏名' }}</label>
                <div class="control">
                    <input v-model='orderName' class="input" type="text" :readonly="requiresGuardianName || !!selectedChild" :placeholder="requiresGuardianName ? 'プロフィール設定から登録してください' : '2年3組 見本太郎'" required>
                </div>
            </div>
            <div class="field">
                <label class="label">メールアドレス</label>
                <div class="control has-icons-left has-icons-right">
                    <input v-model='email' class="input" type="email" placeholder="example@photoorder.jp" required>
                    <span class="icon is-small is-left">
                        <i class="fas fa-envelope"></i>
                    </span>
                </div>
            </div>
            <div class='field'>
                <label class='label'>携帯電話番号、またはご自宅電話番号</label>
                <div class='control has-icons-left'>
                    <input v-model='phone' class='input' type='tel' pattern="\d{10,11}" placeholder='ハイフンなし、半角のみ' required/>
                    <span class='icon is-small is-left'>
                        <i class='fas fa-phone'></i>
                    </span>
                </div>
            </div>
            <div class="field">
                <label class="label">郵便番号</label>
                <div class="control">
                    <input v-model='postal' class="input" type="text" pattern="\d{7,7}" placeholder="ハイフンなし、半角のみ" required>
                </div>
            </div>
            <div class="field">
                <label class="label">住所</label>
                <div class="control">
                    <input v-model='address' class="input" type="text" placeholder="都道府県 市区町村 番地 建物名 部屋番号" required>
                </div>
            </div>
            <!-- <div class="field">
                <label class="label">写真サイズ</label>
                <div class="control">
                    <div class="select">
                        <select v-model='selectSize' required>
                            <option value='' disabled>選択してください</option>
                            <option v-for='size in sizes' :key='size.id' :value='size'>
                                <span>{{ size.name }}({{ size.price }}円)</span>
                            </option>
                        </select>
                    </div>
                </div>
            </div> -->
            <div class="order-field">
                <label class="label">配送方法</label>
                <select class='order-select' v-model='selectDelivery' required>
                    <option v-for='delivery in displayDeliverys' :key='delivery.id' :value='delivery'>
                        <span>{{ delivery.name }}({{ deliveryPrice(delivery) }}円)</span>
                    </option>
                </select>
                <p v-if='isDataOnlyOrder' class='data-only-note'>データ販売のみの注文は送料がかかりません。</p>
            </div>
            <div class="order-field">
                <label class="label">決済方法</label>
                <select class='order-select' v-model='selectPayment' required>
                    <option v-for='payment in displayPayments' :key='payment.id' :value='payment'>
                        {{ paymentOptionText(payment) }}
                    </option>
                </select>
            </div>
            <div class="field">
                <label class="label">コメント</label>
                <div class="control">
                    <textarea v-model='comment' class="textarea" placeholder=""></textarea>
                </div>
            </div>
            <div class='price-wrapper'>
                <label class="label">料金</label>
                <div class='price-table'>
                    <div class='price-row'>
                        <span class='price-description'>写真合計</span>
                        <span class='price-amount'>{{ photos.length }}枚</span>
                    </div>
                    <div v-for="val in buySizeArray" v-bind:key="val.size + val.price" class="price-row">
                        <span class='price-description price-size-description'>
                            {{ val.size }}<span class='price-unit'>({{ val.price }}円)</span> × <span class='price-unit'>{{ val.length }}枚</span>
                        </span>
                        <span class='price-amount'>{{ val.length * val.price }}円</span>
                    </div>
                    <div v-if='selectDelivery.name' class='price-row'>
                        <span class='price-description'>配送料</span>
                        <span class='price-amount'>{{ effectiveDeliveryFee }}円</span>
                    </div>
                    <div v-if='selectPayment.name === paymentMethod.CREDIT_CARD' class='price-row'>
                        <span class='price-description'>決済手数料</span>
                        <span class='price-amount'>{{ cardFee }}%</span>
                    </div>
                    <div v-else-if='selectPayment.name === paymentMethod.CONVENIENCE_STORE' class='price-row'>
                        <span class='price-description'>決済手数料</span>
                        <span class='price-amount'>{{ conveniFee }}円</span>
                    </div>
                    <div v-else-if='isCustomerBornePaymentFee(selectPayment)' class='price-row'>
                        <span class='price-description'>決済手数料</span>
                        <span class='price-amount'>お客様負担</span>
                    </div>
                    <div v-else-if='selectPayment.name' class='price-row'>
                        <span class='price-description'>決済手数料</span>
                        <span class='price-amount'>{{ selectPayment.price }}円</span>
                    </div>
                    <div v-if='selectDelivery.name && selectPayment.name' class='price-row price-total'>
                        <span class='price-description'>合計料金</span>
                        <span class='price-amount'>{{ totalAmount }}円</span>
                    </div>
                    <div v-else class='price-message'>
                        写真サイズ、配送方法、決済方法を選択してください
                    </div>
                </div>
            </div>
        </form>
        <div class="control">
            <button class="button is-primary is-fullwidth is-medium" :disabled='sending || (requiresGuardianName && !guardianName)' @click='order'>注文確定</button>
        </div>
    </div>
</template>

<script>
import { isAvailableSize } from '@/helpers/printSize'
import { CUSTOMER_BORNE_PAYMENT_FEE_TEXT, isCustomerBornePaymentFee } from '../../../helpers/payment'
import { PAYMENT_METHOD, DELIVERY_METHOD } from '../../../constants/orderOption'

const DATA_SALE_SIZE_NAME = 'データ販売'
const DATA_ONLY_DELIVERY = Object.freeze({
    id: 'data-only',
    name: DELIVERY_METHOD.DATA_ONLY,
    price: 0,
    use: true
})

export default {
    name: 'EventList',
    components: {
    },
    props: ['cart'],
    data () {
        return {
            name: '',
            guardianName: '',
            children: [],
            childId: '',
            email: '',
            postal: '',
            address: '',
            phone: '',
            selectDelivery: {},
            selectPayment: {},
            comment: '',
            photos: [],
            orderPhotos: [],
            payments: [],
            deliverys: [],
            buySizeArray: [],
            photoAmount: 0,
            cardFee: 0,
            conveniFee: 0,
            paymentMethod: PAYMENT_METHOD,
            customerBornePaymentFeeText: CUSTOMER_BORNE_PAYMENT_FEE_TEXT,
            sending: false
        }
    },
    computed: {
        selectedChild () { return this.children.find(child => child.id === this.childId) || null },
        requiresGuardianName () {
            return !this.isDataOnlyOrder && [DELIVERY_METHOD.YUU_PACKET, DELIVERY_METHOD.NEKOPOS, DELIVERY_METHOD.HOME_DELIVERY].includes(this.selectDelivery.name)
        },
        orderName: {
            get () { return this.requiresGuardianName ? this.guardianName : (this.selectedChild ? this.selectedChild.name : this.name) },
            set (value) { if (!this.requiresGuardianName) this.name = value }
        },
        displayDeliverys () {
            if (this.isDataOnlyOrder) return [DATA_ONLY_DELIVERY]
            return this.deliverys.filter((delivery) => { return delivery.use === true })
        },
        isDataOnlyOrder () {
            return this.orderPhotos.length > 0 && this.orderPhotos.every((photo) => {
                return photo.size === DATA_SALE_SIZE_NAME
            })
        },
        effectiveDeliveryFee () {
            if (this.isDataOnlyOrder) return 0
            return Number(this.selectDelivery.price) || 0
        },
        displayPayments () {
            const payments = this.payments.map((payment) => {
                if (payment.name === PAYMENT_METHOD.CONVENIENCE_STORE) {
                    payment.price = this.conveniFee
                }
                return payment
            })
            return payments.filter((payment) => { return payment.use === true })
        },
        totalAmount () {
            const baseAmount = this.photoAmount + this.effectiveDeliveryFee

            if (this.selectPayment.name === PAYMENT_METHOD.CREDIT_CARD) {
                return Math.ceil(baseAmount * (1 + Number(this.cardFee) * 0.01))
            }
            if (this.selectPayment.name === PAYMENT_METHOD.CONVENIENCE_STORE) {
                return baseAmount + (Number(this.conveniFee) || 0)
            }
            if (this.isCustomerBornePaymentFee(this.selectPayment)) {
                return baseAmount
            }
            return baseAmount + (Number(this.selectPayment.price) || 0)
        }
    },
    mounted () {
        const self = this

        self.axios.post(`${process.env.API_URL}/photobuy/order/info`, {
            photos: self.cart,
            photographerId: self.$route.query.pgi
        }).then((res) => {
            if (res.data.message !== 'OK') {
                self.$root.$emit('notification', 'is-danger', '注文できる写真がありません')
                self.$router.push('/photobuy/cart')
                return
            }

            self.name = res.data.name
            self.guardianName = res.data.guardianName || ''
            self.children = res.data.children || []
            self.email = res.data.email
            self.postal = res.data.postal
            self.address = res.data.address
            self.phone = res.data.phone
            self.photos = res.data.photos
            self.cardFee = res.data.cardFee
            self.conveniFee = res.data.conveniFee

            const events = res.data.events
            const eventMap = {}
            const availablePhotos = {}
            events.forEach(event => { eventMap[event.id] = event })
            self.photos.forEach(photo => { availablePhotos[photo.id] = photo })
            const invalidSize = self.cart.some(selection => {
                const photo = availablePhotos[selection.id]
                if (!photo) return false
                const event = eventMap[photo.event_id]
                return !event || !isAvailableSize(event.setting.sizes, selection.size)
            })
            if (invalidSize) {
                self.$root.$emit('notification', 'is-warning', '販売サイズが変更された写真があります。カートでサイズを選び直してください')
                self.$router.push('/photobuy/cart')
                return
            }

            self.payments = events[0].setting.payments
            self.deliverys = events[0].setting.deliverys

            const eventSizeMap = {}
            const cartSizeMap = {}
            const photoMap = {}

            for (const photo of self.photos) {
                photoMap[photo.id] = photo
            }

            self.orderPhotos = self.cart.filter((photo) => {
                return photoMap[photo.id]
            })
            if (self.orderPhotos.length !== self.cart.length) {
                self.$root.$emit('cartReplace', self.orderPhotos)
            }

            for (const event of events) {
                eventSizeMap[event.id] = {}
                for (const size of event.setting.sizes) {
                    eventSizeMap[event.id][size.name] = size.price
                }
            }

            for (const photo of self.orderPhotos) {
                cartSizeMap[photo.id] = { size: photo.size, length: photo.length }
            }

            self.photoAmount = 0
            const sizePriceMap = {}

            for (const photo of self.photos) {
                const size = cartSizeMap[photo.id].size
                const price = eventSizeMap[photo.event_id][size]

                if (!sizePriceMap[size]) sizePriceMap[size] = {}
                if (!sizePriceMap[size][price]) sizePriceMap[size][price] = 0

                sizePriceMap[size][price] += cartSizeMap[photo.id].length
                self.photoAmount += price * cartSizeMap[photo.id].length
            }

            for (const size in sizePriceMap) {
                for (const price in sizePriceMap[size]) {
                    self.buySizeArray.push({ size, price, length: sizePriceMap[size][price] })
                }
            }

            self.buySizeArray.sort((a, b) => {
                if (a.size === b.size) {
                    return a.price > b.price
                }
                return a.size > b.size
            })

            // デフォルトで最初の配送方法・決済方法を選択
            if (self.displayDeliverys.length > 0) {
                self.selectDelivery = self.displayDeliverys[0]
            }
            if (self.displayPayments.length > 0) {
                self.selectPayment = self.displayPayments[0]
            }
        }).catch((e) => {
            console.log(e)
            alert('サーバーに問題が発生しています')
        })
    },
    methods: {
        isCustomerBornePaymentFee,
        paymentFeeText (payment) {
            if (this.isCustomerBornePaymentFee(payment)) {
                return this.customerBornePaymentFeeText
            }
            if (payment.name === PAYMENT_METHOD.CREDIT_CARD) {
                return `${this.cardFee}%`
            }
            if (payment.name === PAYMENT_METHOD.CONVENIENCE_STORE) {
                return `${this.conveniFee}円`
            }
            return `${payment.price}円`
        },
        paymentOptionText (payment) {
            return `${payment.name}(${this.paymentFeeText(payment)})`
        },
        deliveryPrice (delivery) {
            if (this.isDataOnlyOrder) return 0
            return Number(delivery.price) || 0
        },
        order () {
            const self = this
            if (self.requiresGuardianName && !self.guardianName) {
                self.$root.$emit('notification', 'is-warning', 'プロフィール設定で保護者氏名を登録してください')
                return
            }
            self.sending = true

            if (document.getElementsByClassName('form')[0].reportValidity()) {
                self.axios.post(`${process.env.API_URL}/photobuy/order`, {
                    photos: JSON.stringify(self.orderPhotos),
                    buySizeArray: JSON.stringify(self.buySizeArray),
                    name: self.orderName,
                    childId: self.childId,
                    email: self.email,
                    postal: self.postal,
                    address: self.address,
                    phone: self.phone,
                    comment: self.comment,
                    delivery: self.selectDelivery,
                    payment: self.selectPayment,
                    photographerId: self.$route.query.pgi
                }).then((res) => {
                    self.$root.$emit('cartClear')
                    if (res.data.url) {
                        location.href = res.data.url
                    } else {
                        self.$router.push('/photobuy/order/complete')
                    }
                }).catch((e) => {
                    if (e.response && e.response.data && e.response.data.code === 'guardian_name_required') {
                        self.$root.$emit('notification', 'is-warning', 'プロフィール設定で保護者氏名を登録してください')
                        self.$router.push('/photobuy/mypage?to=profile')
                    } else if (e.response && e.response.data && e.response.data.code === 'invalid_child') {
                        self.$root.$emit('notification', 'is-warning', 'お子さまの登録情報が変更されました。注文画面を開き直して選択してください')
                    } else if (e.response && e.response.status === 400) {
                        alert('注文を完了できませんでした。入力内容をご確認のうえ再度お試しください')
                    } else {
                        alert('サーバーに問題が発生しています')
                    }
                    self.sending = false
                })
            } else {
                self.sending = false
            }
        }
    }
}
</script>

<style scoped>

.main {
    max-width: 1280px;
    min-height: calc(100vh - 80px);
    margin: auto;
    padding: 20px;
}

.field {
    min-width: 520px;
}

.button {
    margin-top: 40px;
}

.none {
    display: none;
}

.price-wrapper {
    margin-top: 40px;
    margin-bottom: 30px;
    max-width: 560px;
}

.price-table {
    width: 100%;
}

.price-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) max-content;
    column-gap: 24px;
    align-items: baseline;
    min-height: 28px;
    line-height: 1.4;
}

.price-description {
    min-width: 0;
    word-break: break-word;
}

.price-size-description {
    padding-left: 16px;
}

.price-unit {
    font-weight: 600;
}

.price-amount {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
}

.price-total {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #ddd;
    font-weight: bold;
}

.price-message {
    margin-top: 8px;
}

.order-field {
    margin-bottom: 20px;
}

.order-select {
    min-width: 220px;
}

.data-only-note {
    margin-top: 6px;
    color: #27744a;
    font-size: 13px;
}

@media (max-width: 600px) {
    .field {
        min-width: 80vw;
    }

    .price-wrapper {
        max-width: 100%;
    }

    .price-row {
        column-gap: 12px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/photobuy/pages/Order.vue